import React from 'react';

import { Description, Title } from '../typography';
import { RegisterCreatorImg, RegisterTeacherImg } from '../../assets/images';
import { CheckList, Option, OptionList } from './styles';
import { RoleSelectorProps } from './types';
import { lang } from '../../lang';

function RoleSelector({ onSelect }: RoleSelectorProps) {
  return (
    <OptionList>
      <Option onClick={() => onSelect(1)}>
        <img src={RegisterCreatorImg} alt="Student or Creator" />
        <CheckList>
          <Title size="small" className="title">{lang('auth.signup.student.label')}</Title>
          <Description>
            &#10003;
            {' '}
            {lang('auth.signup.student.item_1')}
          </Description>
          <Description>
            &#10003;
            {' '}
            {lang('auth.signup.student.item_2')}
          </Description>
          <Description>
            &#10003;
            {' '}
            {lang('auth.signup.student.item_3')}
          </Description>
        </CheckList>
      </Option>
      <Option onClick={() => onSelect(2)}>
        {/* <Circle /> */}
        <img src={RegisterTeacherImg} alt="Teacher" />
        <CheckList>
          <Title size="small" className="title">{lang('auth.signup.teacher.label')}</Title>
          <Description>
            &#10003;
            {' '}
            {lang('auth.signup.teacher.item_1')}
          </Description>
          <Description>
            &#10003;
            {' '}
            {lang('auth.signup.teacher.item_2')}
          </Description>
          <Description>
            &#10003;
            {' '}
            {lang('auth.signup.teacher.item_3')}
          </Description>
        </CheckList>
      </Option>
    </OptionList>
  );
}

export default RoleSelector;
